import { TInitUserReqDto, TInitUserResDto } from "@/api/services/main/user/dtos/init-user.dto";
import { TMintOauthRedirectReqDto, TMintOauthRedirectResDto } from "@/api/services/main/user/dtos/mint-oauth-redirect.dto";
import { clientApi } from "@/utils/api";

// Provisions the product account (first login) WITHOUT minting a redirect. Idempotent.
// The redirect itself is minted later, on the /mint-oauth-redirect page, right before navigating —
// the handoff token only lives 60s server-side, so minting must stay close to the actual navigation.
export const initUserApi = async (payload: TInitUserReqDto): Promise<TInitUserResDto> => {
  const { data } = await clientApi.post<TInitUserResDto>("/users/init", payload);
  return data;
};

// Mints the single-use SSO redirect URL. Self-heals by provisioning first when the user has no
// product account yet, so entering the page directly still works.
export const mintOauthRedirectApi = async (payload: TMintOauthRedirectReqDto): Promise<TMintOauthRedirectResDto> => {
  const { data } = await clientApi.post<TMintOauthRedirectResDto>("/users/mint-oauth-redirect", payload);
  return data;
};
